import React, { useState } from 'react';
import { api } from '../api';
import { MessageSquare, Send, CheckCircle2, MapPin, Mail, Building2 } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const inputCls = 'w-full px-4 py-3 rounded-2xl border-2 border-[#1a1a1a] font-brico bg-white focus:outline-none focus:ring-2 focus:ring-[#E63946]';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', order_id: '', subject: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post('/complaints', form);
      setDone(true);
      setForm({ name: '', email: '', phone: '', order_id: '', subject: '', message: '' });
      toast({ title: 'We got it!', description: 'Our team will get back to you shortly.' });
      setTimeout(() => setDone(false), 6000);
    } catch (err) {
      toast({ title: 'Could not send', description: err?.response?.data?.detail || 'Please try again.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="px-5 md:px-8 py-16 md:py-24 bg-[#FFF4E6]">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8">
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-[#E63946]">Contact us</div>
          <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] mt-2">Got a<br />query?</h2>
          <p className="font-brico text-lg mt-4 opacity-70 max-w-md">Complaints, questions or feedback — drop us a line and our team will reach out.</p>

          <div className="mt-6 bg-white rounded-3xl crunch-shadow p-6 space-y-4">
            <div>
              <div className="text-[10px] font-bold uppercase tracking-widest opacity-60 flex items-center gap-1"><Building2 size={12} /> Registered Office</div>
              <div className="font-brico font-bold mt-1">Better Grain Foods Private Limited</div>
              <div className="font-brico text-sm opacity-80 flex items-start gap-1 mt-1">
                <MapPin size={14} className="mt-0.5 flex-shrink-0" />
                <span>Tukum Ward, Desaiganj (Wadsa) 441207, Maharashtra, India</span>
              </div>
            </div>
            <div className="pt-3 border-t border-black/10">
              <div className="text-[10px] font-bold uppercase tracking-widest opacity-60 flex items-center gap-1"><Mail size={12} /> Email</div>
              <a href="mailto:care@trucrunch.in" className="font-display text-xl block mt-1 hover:text-[#E63946]">care@trucrunch.in</a>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="bg-white rounded-3xl crunch-shadow p-6 md:p-8 space-y-3">
          <div className="flex items-center gap-2">
            <MessageSquare size={18} className="text-[#E63946]" />
            <div className="font-display text-2xl uppercase">Submit a Query / Complaint</div>
          </div>
          {done && (
            <div className="flex items-center gap-2 bg-[#2A9D8F] text-white rounded-2xl p-3 font-brico font-semibold">
              <CheckCircle2 size={18} /> Your message is in. We'll get back on email.
            </div>
          )}
          <div className="grid grid-cols-2 gap-3">
            <input required placeholder="Your Name *" className={inputCls} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <input required type="email" placeholder="Email *" className={inputCls} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <input placeholder="Phone (optional)" className={inputCls} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
            <input placeholder="Order ID (if any)" className={inputCls} value={form.order_id} onChange={(e) => setForm({ ...form, order_id: e.target.value })} />
          </div>
          <input required placeholder="Subject *" className={inputCls} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
          <textarea required rows={5} placeholder="How can we help? *" className={inputCls} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
          <button disabled={submitting} type="submit" className="btn-chunky primary w-full justify-center">
            <Send size={16} /> {submitting ? 'Sending…' : 'Submit'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
